import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckIcon } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: <div className="flex text-brand-gold mr-1" data-id="element-209">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-210" />)}
        </div>,
    text: '4.9 · 595 Google Reviews'
  }, {
    icon: <CheckIcon className="w-5 h-5 text-brand-dark mr-2" data-id="element-211" />,
    text: 'ASE-Certified Technicians'
  }, {
    icon: <CheckIcon className="w-5 h-5 text-brand-dark mr-2" data-id="element-212" />,
    text: '2-Year / 24,000-Mile Warranty'
  }, {
    icon: <CheckIcon className="w-5 h-5 text-brand-dark mr-2" data-id="element-213" />,
    text: 'Serving St. Paul Since 1977'
  }];
  return <div className="py-4 px-4 border-y border-brand-accentHover shadow-inner bg-[#c8b4a4]" data-id="element-214">
      <div className="max-w-6xl mx-auto" data-id="element-215">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-y-4 gap-x-8" data-id="element-216">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-center text-brand-dark font-bold text-sm md:text-base text-center" data-id="element-217">
              {item.icon}
              <span data-id="element-218">{item.text}</span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}